import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.BUSCAR_FORNECEDORES]({ state }, idAtaItem) {
		const { data } = await api.fornecedorItemAta.buscarFornecedoresPorIdItemAtaPaginado(state.paginacao, idAtaItem)
		return data
	},

	async [actionTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.ALTERAR_CLASSIFICACAO]({ getters }) {
		const { dadosAlterar } = getters
		await api.alterarClassificacao.alterarClassificacao(dadosAlterar)
	},
}
